export const groupByCounty = (records = []) => {
  const map = {};
  (records || []).forEach(r => {
    if (!r.county?.trim()) return;
    if (!map[r.county]) map[r.county] = { county: r.county, municipalities: [], cities: [] };
    if (r.city?.trim()) map[r.county].municipalities.push({ id: r._id, city: r.city });
    if (r.countyCity?.trim()) map[r.county].cities.push({ id: r._id, city: r.countyCity });
  });
  return Object.values(map).sort((a, b) => a.county.localeCompare(b.county));
};

export const getOptionsFromRecords = records => {
  const counties = groupByCounty(records);
  const countyNames = counties.map(c => c.county);
  const municipalityNames = [
    ...new Set((records || []).filter(r => r.city?.trim()).map(r => r.city.trim()))
  ].sort((a, b) => a.localeCompare(b));
  const cityNames = [
    ...new Set((records || []).filter(r => r.countyCity?.trim()).map(r => r.countyCity.trim()))
  ].sort((a, b) => a.localeCompare(b));
  return { countyNames, municipalityNames, cityNames };
};


export const resolveCountyForCity = (records, cityInput) => {
  const t = cityInput?.trim();
  if (!t) return null;
  const matches = (records || []).filter(r => r.city?.trim() === t && r.county?.trim());
  const counties = [...new Set(matches.map(r => r.county.trim()))];
  if (counties.length > 0) return counties[0];
  return null;
};
